export const version = '0.385.1'
export const chameleonWebVersion = '0.0.0-snapshot-20230412094309'
